import React, { useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link, useNavigate } from 'react-router-dom';
import {
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    Stack,
    TextField
} from '@mui/material';
import './MailingListForm.css';
import { mailingListUpdate } from '../Services/Axios';

function MailingListForm() {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    const [formData, setFormData] = useState({
        'email': '',
        'guardianName': '',
        'childName': '',
        'hasPriorExperience': false,
        'whyMusicTherapy': ''
    });

    const submitForm = () => {
        // TODO: add validation
        mailingListUpdate(formData)
        .then(res => {
            navigate("/home");
            // TODO: add a Snackbar component to alert user on success/error
        })
        .catch(err => {
            console.log(err);
        });
    }

    const handleFieldChange = (event, field) => {
        const form = { ...formData };
        if (field === "hasPriorExperience") {
            form[field] = event.target.checked;
        } else {
            form[field] = event.target.value;
        }

        setFormData(form);
    }

    return (
        <div className="main-form-page">
            <div className="form-section">
                <h1>Sign up here</h1>
                <h5>Join the mailing list to stay on top of the latest events and scheduling opportunities!</h5>
                <FormControl className="form-container">
                    <FormLabel>Email Address</FormLabel>
                    <TextField
                        value={formData.email}
                        onChange={(event) => handleFieldChange(event, 'email')}
                        variant="standard"
                        required
                    />

                    <FormLabel className="mailing-form-label">Parent/Guardian Name</FormLabel>
                    <TextField
                        value={formData.guardianName}
                        onChange={(event) => handleFieldChange(event, 'guardianName')}
                        variant="standard"
                        required
                    />

                    <FormLabel className="mailing-form-label">Child Name</FormLabel>
                    <TextField
                        value={formData.childName}
                        onChange={(event) => handleFieldChange(event, 'childName')}
                        variant="standard"
                        required
                    />

                    <div>
                        <FormLabel className="mailing-form-label">Have we worked together before?</FormLabel>
                        <Checkbox
                            value={formData.hasPriorExperience}
                            onClick={(event) => handleFieldChange(event, 'hasPriorExperience')}
                        />
                    </div>

                    <FormLabel className="mailing-form-label">Why are you seeking music therapy?</FormLabel>
                    <TextField
                        value={formData.whyMusicTherapy}
                        onChange={(event) => handleFieldChange(event, 'whyMusicTherapy')}
                        variant="standard"
                        multiline
                    />

                    <Stack className="form-button-container" direction={isMobile ? 'column' : 'row'} spacing={2}>
                        <Button variant="contained" className="form-button" onClick={submitForm}>Submit</Button>
                        <Link to="/home">
                            <Button variant="outlined" className="form-button">Close</Button>
                        </Link>
                    </Stack>

                </FormControl>
            </div>
        </div>
    )
}

export default MailingListForm;

//<div className="form-button-container"></div>

// <div className="form-container">
//     <form>
//         <label className="form-label">Email Address</label><br/>
//         <input className="form-element" type="text" value={formData.email} onChange={(event) => handleFieldChange(event, 'email')} /><br/>
//         <label className="form-label">Parent/Guardian Name</label><br/>
//         <input className="form-element" type="text" value={formData.guardianName} onChange={(event) => handleFieldChange(event, 'guardianName')} /><br/>
//         <label className="form-label">Child Name</label><br/>
//         <input className="form-element" type="text" value={formData.childName} onChange={(event) => handleFieldChange(event, 'childName')} /><br/>
//         <label className="form-label">Have we worked together before?</label><br/>
//         <input className="form-element" type="checkbox" value={formData.hasPriorExperience.toString()} onChange={(event) => handleFieldChange(event, 'hasPriorExperience')} /><br/>
//         <label className="form-label">Why are you seeking music therapy?</label><br/>
//         <input className="form-element" type="text" value={formData.whyMusicTherapy} onChange={(event) => handleFieldChange(event, 'whyMusicTherapy')} /><br/>
//         <div className="form-button-container">
//             <nav><Link to="/home">
//                 <button className="form-button close">Close</button>
//             </Link></nav>
//             <button onClick={submitForm} className="form-button submit">Submit</button>
//         </div>
//     </form>
// </div>